import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit
} from "@angular/core";
import {Subscription} from "rxjs";
import {ResponsiveService} from "../orchestration/responsive.service";

@Directive({
    selector: "[woa-element-width]"
})
export class ElementWidthDirective implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
    @Input() widthProperty: string = "--woa-element-width";

    private subscriptions: Subscription = new Subscription();
    private elementWidth: number = undefined;
    private destroyed: boolean = false;

    constructor(private element: ElementRef,
                private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: ResponsiveService) {
    }

    ngOnInit(): void {
        this.setElementWidthProperty();
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => this.setElementWidthProperty()));
    }

    ngAfterViewInit(): void {
        this.setElementWidthProperty();
    }

    ngAfterContentInit(): void {
        this.setElementWidthProperty();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.destroyed = true;
    }

    private setElementWidthProperty(): void {
        setTimeout(() => {
            if (this.element && !this.destroyed) {
                const elementWidth: number = this.element.nativeElement.clientWidth;
                if (elementWidth !== this.elementWidth) {
                    this.elementWidth = elementWidth;
                    this.element.nativeElement.style.setProperty(this.widthProperty, elementWidth);
                    this.changeDetectorRef.detectChanges();
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/html-utils/element-width.directive.ts